import {defineMessages} from "react-intl";

export const FoundFlightsSectionMessages = defineMessages({
  foundFlights: {
    id: 'newTripRequestPage.foundFlights',
    defaultMessage: 'Найденные рейсы',
  },
  sortByPrice: {
    id: 'newTripRequestPage.sortByPrice',
    defaultMessage: 'Сортировка по цене',
  },
  price: {
    id: 'newTripRequestPage.price',
    defaultMessage: 'Цена',
  },
  route: {
    id: 'newTripRequestPage.route',
    defaultMessage: 'Маршрут',
  },
  availabilityPeriod: {
    id: 'newTripRequestPage.availabilityPeriod',
    defaultMessage: 'Период доступности',
  },
  pax: {
    id: 'newTripRequestPage.pax',
    defaultMessage: 'PAX',
  },
  departTime: {
    id: 'newTripRequestPage.departTime',
    defaultMessage: 'Depart time',
  },
  arrivalTime: {
    id: 'newTripRequestPage.arrivalTime',
    defaultMessage: 'Время подлета',
  },
  baseAirport: {
    id: 'newTripRequestPage.baseAirport',
    defaultMessage: 'Аэродром базирования',
  },
  aircraftCategory: {
    id: 'newTripRequestPage.aircraftCategory',
    defaultMessage: 'Категория самолета',
  },
  routeTooltip: {
    id: 'newTripRequestPage.routeTooltip',
    defaultMessage: 'Please note that the selected flight departs from or arrives at an airport near your original search location, not the exact airport you specified',
  },
  arrivalTimeTooltip: {
    id: 'newTripRequestPage.arrivalTimeTooltip',
    defaultMessage: 'The aircraft is located far from the departure point. It is available for booking, but may require additional time or expenses for the flight',
  },
  priceNotCalculated: {
    id: 'newTripRequestPage.priceNotCalculated',
    defaultMessage: 'Price not calculated',
  },
  availabilityWarning: {
    id: 'newTripRequestPage.availabilityWarning',
    defaultMessage: 'Aircraft availability may be limited. Please contact the operator for details.',
  },
  adjustedDepartureWarning: {
    id: 'newTripRequestPage.adjustedDepartureWarning',
    defaultMessage: 'Departure time is {timeDifference} later than requested due to schedule conflict',
  },
  positioning: {
    id: 'newTripRequestPage.positioning',
    defaultMessage: 'Positioning',
  },
  positioningTechnicalStops: {
    id: 'newTripRequestPage.positioningTechnicalStops',
    defaultMessage: 'Технические остановки позиционирования',
  },
});
